import { useState, useEffect } from "react";
import { collection, addDoc } from "firebase/firestore";
import db from "../../firebase";
import { LeadMap } from "../../utils/LeadMap";

const TaskForm = () => {
  const [formData, setFormData] = useState({
    taskName: "",
    startDate: "",
    endDate: "",
    taskType: "",
    lead: "",
    notes: "",
  });

  // Auto-update lead based on task type
  useEffect(() => {
    if (formData.taskType) {
      setFormData((prev) => ({ ...prev, lead: LeadMap[formData.taskType] }));
    }
  }, [formData.taskType]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, "tasks"), formData);
      alert("✅ Task assigned successfully!");
      setFormData({
        taskName: "",
        startDate: "",
        endDate: "",
        taskType: "",
        lead: "",
        notes: "",
      });
    } catch (error) {
      console.error("Error adding task: ", error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="task-form">
      <div className="form-row">
        <input type="text" name="taskName" placeholder="Task Name" value={formData.taskName} onChange={handleChange} required />
        <input type="date" name="startDate" value={formData.startDate} onChange={handleChange} required />
        <input type="date" name="endDate" value={formData.endDate} onChange={handleChange} required />

        <select name="taskType" value={formData.taskType} onChange={handleChange} required>
          <option value="">Select Task Type</option>
          <option value="graphics">Graphics</option>
          <option value="video">Video</option>
          <option value="research">Research</option>
          <option value="marketing">Marketing</option>
        </select>

        <input type="text" name="lead" value={formData.lead} placeholder="Lead" readOnly />
      </div>

      <textarea name="notes" value={formData.notes} placeholder="Notes / Remarks" onChange={handleChange} />

      <button type="submit">Assign Task</button>
    </form>
  );
};

export default TaskForm;
